
import { Component, Mixins } from "vue-property-decorator";
import { IEmptyAlertBehavior } from "../../../../../../documaker/domain/format/objects";
import { IEmptyAlertBehaviorPropertyEditable, instanceOfIEmptyAlertBehaviorPropertyEditable } from "../../../../../domain/editableFormat/properties";

@Component
export default class EmptyAlertBehaviorPropertyEditableMixin extends Mixins() {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: IEmptyAlertBehaviorPropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IEmptyAlertBehaviorPropertyEditable) => T, defaultValue: T) => T;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isEmptyAlertBehaviorEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfIEmptyAlertBehaviorPropertyEditable(s) && s.emptyAlertBehavior().isEditable(), false);
  }

  get emptyAlertBehavior(): IEmptyAlertBehavior {
    return this.readPropertyOrDefault(s => s.emptyAlertBehavior().getValue(), { isEnable: false });
  }

  set emptyAlertBehavior(value: IEmptyAlertBehavior) {
    this.writePropertyWhenValid(s => s.emptyAlertBehavior().setValue(value));
  }
}
